import React from 'react';

import {
  RESMIO_PRIVACY_POLICY_URL,
  RESMIO_TERMS_CONDITIONS_URL,
} from 'app/constants';
import FormCheckbox from './FormCheckbox';

function AcceptTOSCheckbox(props) {
  return (
    <FormCheckbox
      name="terms_of_service_accepted"
      hint={
        <span
          dangerouslySetInnerHTML={{
            __html: i18n.sprintf(
              i18n.gettext(
                'Yes, I accept resmio\'s <a href="%s" target="_blank">Terms & Conditions</a>, <a href="%s" target="_blank">Privacy Policy</a> and <a href="%s" target="_blank">Data Processing Agreement</a> (DPA).'
              ),
              RESMIO_TERMS_CONDITIONS_URL,
              RESMIO_PRIVACY_POLICY_URL,
              i18n.gettext(
                'https://www.resmio.com/wp-content/uploads/resmio-AVV-DE.pdf'
              )
            ),
          }}
        />
      }
      {...props}
    />
  );
}

export default AcceptTOSCheckbox;
